import React, { useState } from 'react';
import DateMoment from '@date-io/moment';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import styles from "../../AccountVerificationForm/AccountVerificationForm.module.css"

export default function EligibilityDate(props) {
  const {
    question,
    handlerInputChange,
    value,
    minDate,
    maxDate,
    minDateMessage,
    maxDateMessage
  } = props;

  const [selectedDate, setSelectedDate] = useState(value || null);
  
  const onChange = (...value) => {
    setSelectedDate(value[0]);
    handlerInputChange([value[0]?.toDate() || "", value[1]], question.id);
  }

  return (
    <MuiPickersUtilsProvider utils={DateMoment}>
      <KeyboardDatePicker
        id={`${question.id}Picker`}
        label={
          question.required ? (
            <div>
              {question.label}
              <span
                style={{
                  color: "red",
                  fontSize: "16px",
                  fontWeight: "bold",
                }}
              >
                *
              </span>
              {" "}
              {question.helpText &&
                <div className={ styles.tooltip}> ?
                  <span className={ styles.tooltipText} >{question.helpText}</span>
                </div>
              }
            </div>
          ) : (
            <div>
                {question.label}
                <span style={{ fontSize: "16px"}} > {" "} </span>
                {question.helpText &&
                  <div className={ styles.tooltip}> ?
                    <span className={ styles.tooltipText} >{question.helpText}</span>
                  </div>
                }
            </div>
          )}
        format={question.field.format}
        value={selectedDate}
        InputLabelProps={{
          shrink: true,
        }}
        placeholder={question.placeholder}
        initialFocusedDate={new Date()}
        onChange={onChange}
        disableFuture={question.field.disableFuture || false}
        disablePast={question.field.disablePast || false}
        autoOk={true}
        maxDate={maxDate}
        minDate={minDate}
        minDateMessage={minDateMessage || undefined}
        maxDateMessage={maxDateMessage|| undefined}
        variant="inline"
        fullWidth
        KeyboardButtonProps={{
          'aria-label': 'change purchased date',
        }}
      />
    </MuiPickersUtilsProvider>
  );
}
